// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconTriangleArrowTop.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconTriangleArrowTop = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 10 6" fill="currentColor" { ...props }>
    <path d="M5 0.141915L0 5.8562L10 5.8562L5 0.141915Z" />
  </BaseIcon>
);

export default IconTriangleArrowTop;
